import { render, staticRenderFns } from "./Zidian.vue?vue&type=template&id=6f67048b&scoped=true&"
import script from "./Zidian.vue?vue&type=script&lang=js&"
export * from "./Zidian.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f67048b",
  null
  
)

export default component.exports